<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('common.num')">
                    <el-select
                      v-model="formInline.selectCarType"
                      style="width: 120px"
                      :placeholder="$t('common.form.choseTip')"
                      class="selectStyle"
                    >
                      <el-option
                        v-for="item in optionsInput"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <el-input
                      size="mini"
                      v-model="formInline.selectCarValue"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="inputStyle"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.terminalId')">
                    <el-input
                      size="mini"
                      v-model="formInline.terminalId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('SafeManagement.illegalType')">
                    <el-select
                      v-model="formInline.eventCode"
                      :placeholder="$t('SafeManagement.form.illegalType')"
                      filterable
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in alarmTypeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('common.driverNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('common.messageTime')">
                    <el-date-picker
                      v-model="formInline.ReportingTime"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.btn.choseDate')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('VIOLATIONCONTROL_DOWN')" type="text" @click="downCar">{{
                  $t("common.btn.download")
                }}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="800px"
        class="tableDialong"
        :before-close="closeImgDia"
        :title="$t('DriverManagement.filePath')"
        :visible.sync="dialogImgFormVisible"
      >
        <img :src="imgUrl" style="width: 100%" />
      </el-dialog>
      <el-dialog
        width="800px"
        class="tableDialong"
        :before-close="closeVideoDia"
        :title="$t('common.video')"
        :visible.sync="dialogVideoFormVisible"
      >
        <video ref="myVideo" id="my-video" class="video-js" style="width: 100%;"></video>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ViolationControl from "./ViolationControl.js";
export default ViolationControl;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
